import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useApi from "../../CustomHooks/useApi";
import { useToast } from "../../../Contexts/ToastContext";
import { registrationAPI } from "../../../api/apiClient";
import { useTripContext } from "../TripContext";
import "../../../css/View/RegistrationDetails.css";
import Loading from "../../../Loading";
import DOMPurify from "dompurify";

const RegistrationEmailHistory = () => {
  const { resGuid, tripGuid, variantguid } = useParams();
  const { showToast } = useToast();
  const { callApi, isLoading } = useApi();
  const [emails, setEmails] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const { tripData } = useTripContext();

  const getEmailColorClass = (type) => {
    switch (type) {
      case 1: return "email-subject-orange";     // WaitingList
      case 2:
      case 5: return "email-subject-green";      // Confirmed (bez/z zaliczką)
      case 3: return "email-subject-blue";       // Waiting for prepayment
      case 4: return "email-subject-red";        // Cancelled
      case 6: return "email-subject-grey";       // Unfinished
      default: return "email-subject-default";
    }
  };
  

  const registration = tripData?.registrations.find(
    (r) => r.reservationGuid === resGuid
  );

  useEffect(() => {
    callApi(
      () => registrationAPI.getEmailHistory(resGuid),
      setEmails,
      () => showToast("Nie udało się pobrać historii e-maili.", "error")
    );
  }, [resGuid]);

  const toggleExpanded = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const formatDate = (iso) =>
    new Date(iso).toLocaleString("pl-PL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

  return (
    <div className="registration-container">
      <div className="email-history-card">
        <h2 className="email-history-header">
          Historia e-maili{" "}
          <span className="email-history-code">{registration?.reservationCode}</span>
        </h2>

        {isLoading && <Loading text="Ładowanie maili..."/>}
        {!isLoading && emails.length === 0 && (
          <p>Brak wysłanych wiadomości.</p>
        )}

        {emails.map((email, index) => (
         <div
         className="email-history-item shadow-box"
         key={index}
         onClick={() => toggleExpanded(index)}
       >
            <div className="email-header">
            <div className="email-meta"><i className="fa-regular fa-envelope-open" style={{ marginRight: 6 }}></i>{formatDate(email.sentAt)}</div>
            <div className={`email-subject${expandedIndex === index ? ' expanded' : ''} ${getEmailColorClass(email.emailTypeId)}`}>{email.subject}</div>
              
            </div>
            <div className="email-recipient">Do: {email.emailAddress}</div>
            {expandedIndex === index && email.body && (
  <iframe
    title={`Treść wiadomości ${index + 1}`}
    srcDoc={DOMPurify.sanitize(email.body, {
      WHOLE_DOCUMENT: true,
      ADD_TAGS: ["html", "head", "body", "style"],
    })}
    sandbox=""
    referrerPolicy="no-referrer"
    style={{
      width: "100%",
      height: "700px",
      border: "none",
      backgroundColor: "#fff",
    }}
  />
)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RegistrationEmailHistory;
